import React, { useState, useEffect } from "react";
import api from "../api/axios";
import { useNavigate } from "react-router-dom";


const AdminLogin = () => {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
  });
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    
  }, []);


  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

 const handleSubmit = async (e) => {
  e.preventDefault();
  setError("");

  try {
    const response = await api.post("companyblog/admin/login/", {
      username: formData.username,
      password: formData.password,
    });

    localStorage.setItem("access", response.data.access);
    localStorage.setItem("refresh", response.data.refresh);

    localStorage.setItem("user", JSON.stringify(response.data.user));

    navigate("/admin/dashboard");
  } catch (err) {
    setError("Invalid username or password");
  }
};



  return (
    <div className="login-container" style={styles.loginContainer}>
      <form className="login-card" style={styles.loginCard} onSubmit={handleSubmit}>
        <h2 style={styles.heading}>Admin Login</h2>

        {error && <p className="error" style={styles.error}>{error}</p>}

        <input
          type="text"
          name="username"
          placeholder="Username"
          onChange={handleChange}
          style={styles.input}
          required
        />

        <input
          type="password"
          name="password"
          placeholder="Password"
          onChange={handleChange}
          style={styles.input}
          required
        />

        <button type="submit" style={styles.button}>Login</button>
      </form>
    </div>
  );
};

export default AdminLogin;
const styles = {
loginContainer: {
    height: "100vh",
    background: "linear-gradient(135deg, #1f2933, #111827)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  loginCard: {
    width: "350px",
    padding: "35px",
    background: "rgba(255,255,255,0.1)",
    backdropFilter: "blur(12px)",
    borderRadius: "14px",
    boxShadow: "0 15px 35px rgba(0,0,0,0.4)",
    textAlign: "center",
  },

  heading: {
    color: "#fff",
    marginBottom: "25px",
  },

  input: {
    width: "100%",
    padding: "12px",
    marginBottom: "15px",
    borderRadius: "8px",
    border: "none",
    outline: "none",
  },

  button: {
    width: "100%",
    padding: "12px",
    borderRadius: "8px",
    border: "none",
    background: "#2563eb",
    color: "#fff",
    fontSize: "16px",
    cursor: "pointer",
  },

  error: {
    color: "#f87171",
    marginBottom: "10px",
  },
    };